import { render } from "./AppointmentTypesList.vue?vue&type=template&id=7426cdb3&scoped=true"
import script from "./AppointmentTypesList.vue?vue&type=script&lang=js"
export * from "./AppointmentTypesList.vue?vue&type=script&lang=js"

import "./AppointmentTypesList.vue?vue&type=style&index=0&id=7426cdb3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7426cdb3"

export default script